module.exports = __webpack_public_path__ + "static/media/java.ed373fba.png";